@if (formControl()) {
<div class="select form-group">
    <mat-form-field class="form-field">
        <mat-label>{{meta().name}}</mat-label>
        <mat-select [multiple]="!!meta().multiple" [formControl]="formControl()!"
            (selectionChange)="onSelect($event.value)">
            @if (!meta().multiple) {
            <mat-option>--</mat-option>
            }
            @for (option of meta().options; track option[meta().label]) {
            <mat-option [value]="option[meta().value]">
                {{option[meta().label]}}
            </mat-option>
            }
        </mat-select>
        <mat-hint><strong>{{meta().info}}</strong></mat-hint>
        @if (formControl()?.hasError('required')) {
        <mat-error>
            {{meta().name}} is <strong>required</strong>
        </mat-error>
        }
        @if (formControl()?.hasError('form')) {
        <mat-error>
            {{formError}}
        </mat-error>
        }
    </mat-form-field>
</div>
}
